import React from 'react';
import Loader from '../../../common/components/loader';

const ContainerTables = ({loading, children}) => {
  if (loading) {
    return <div className="invoices-loader"> <Loader/> </div>;
  }
  return children;
};

export default ContainerTables;
